import { Injectable, effect, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NGXLogger } from 'ngx-logger';
import { shareReplay } from 'rxjs';
import { JmkwEvent } from '@jeppesen-foreflight/jmkw-types';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private readonly _logger = inject(NGXLogger);
  eventHistory = new Map<string, Map<number, JmkwEvent>>();

  constructor() {
    effect(() => {
      this._logger.trace(`[EventBusService]:`, this.$event());
    });
  }

  // possible idea for logging events over time for a history check.
  // logEventHistory(event: JmkwEvent) {
  //   const timestamp = new Date().getTime();
  //   if (this.eventHistory.has(this.$event().sourceId)) {
  //     const oldEvent = this.eventHistory.get(this.$event().sourceId);
  //     // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  //     oldEvent!.set(timestamp, this.$event());
  //   } else {
  //     this.eventHistory.set(this.$event().sourceId, new Map());
  //     // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  //     this.eventHistory
  //       .get(this.$event().sourceId)!
  //       .set(timestamp, this.$event());
  //   }
  // }

  $event = signal<JmkwEvent>(
    new JmkwEvent(
      'BUS_INIT_EVENT',
      new Event('BusInitializationEvent', {}),
      this
    )
  );

  event$ = toObservable(this.$event).pipe(shareReplay(1));
}
